export default {
  "b2b.produkty-grid.title": "Produkty",
  "b2b.produkty-grid.add": "Přidat produkt"
};
